<template>
  <div class="botm-bar-wrap">
    <offer-applied-message
      v-if="welcomeOffers?.length > 0"
    ></offer-applied-message>
    <!-- disabled to show the payment offer message as of now -->
    <!-- <payment-offer-message v-if="paymentOffers?.length  > 0"></payment-offer-message> -->
    <!-- with-checkout class is added when checkout option is available -->
    <div
      class="bottom-nav active"
      :class="{ 'with-checkout': cartQuantity > 0 }"
    >
      <!-- <span  //commented home btn because of product/android call  
        class="nav-item active"
        v-if="isNewHomeBtnVariant"
        style="border-right: white"
      >
        <div @click="triggerHomeClick($event)" class="nav-item-content pr0">
          <span class="nav-item-text">Home</span>
          <i
            aria-hidden="true"
            class="jfi-logo-active"
            :class="{
              black:
                !productCounterString ||
                productCounterString.startsWith('undefined'),
            }"
          ></i>
        </div>
      </span> -->

      <span class="nav-item active">
        <div @click="triggerMenuClick($event)" class="nav-item-content">
          <span class="nav-item-text">Menu</span>
          <i
            aria-hidden="true"
            class="jfi-menu-full"
            :class="{
              black:
                productCounterString &&
                !productCounterString.startsWith('undefined') &&
                isNewHomeBtnVariant,
            }"
          ></i>
        </div>
      </span>

      <span class="nav-item">
        <div
          class="nav-item-content pl0"
          :class="[isNewHomeBtnVariant ? '' : 'pr32']"
          @click="handlePizza99($event , shouldEdvVisible)"
        >
        <template v-if="isConfigStatic">
          <span class="shimmer-container" style="height: 20px; width: 100px;"></span>
        </template>
        <template v-else-if="!shouldEdvVisible">
            <span class="nav-item-text">Offers</span>
            <i aria-hidden="true" class="jfi-bb-offers"></i>
        </template>
        <template v-else>
          <template v-if="edvRebrandingTitle">
            <span class="nav-item-text">{{ edvRebrandingTitle }}</span>
            <i aria-hidden="true" class="jfi-one-plus-one"></i>
          </template>
          <template v-else>
              <span class="nav-item-text">Pizza@99</span>
              <i aria-hidden="true" class="jfi-tag-v2"></i>
          </template>
        </template>
        </div>
      </span>

      <span class="nav-item cart-nav" @click="handleCartClick($event)">
        <div v-if="cartQuantity >= 0" class="btn btn-checkout disp-col-inline">
          <span class="cart-total">
            <transition name="slide-fade" mode="out-in">
              <span class="count-holder" :key="cartQuantity">{{
                cartQuantity
              }}</span>
            </transition>
            <i aria-hidden="true" class="jfi-cart fs-18"></i>
          </span>
          <span class="ml10 tl">
            <span class="block fs-11" v-if="!hideCartTotal"
              ><span>{{ currencySymbol }}</span>
              <span> {{ cartTotal }} + taxes </span>
            </span>
            <span
              class="block fs-14 bold"
              :class="[hideCartTotal ? 'mt6 mb6' : '']"
              v-html="checkoutTitle"
            ></span>
          </span>
          <i aria-hidden="true" class="jfi-arrow-line fs-16"></i>
        </div>
      </span>
    </div>

    <!-- menu popup -->
    <menu-modal
      v-if="showMenuModal"
      @close-menu-modal="closeModalM()"
      :showModal="showMenuModal"
    ></menu-modal>

    <!-- menu popup -->
    <new-menu-modal
      v-if="
        (isNewHomeBtnVariant || isViewAllCategoryVariant) && showNewMenuModal
      "
    ></new-menu-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { keyMapsGetter } from "../helpers/storeKeys";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import { projectBasePathWithFolder, v2PwaBasePath } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import userActivityTracking from "../helpers/UserActivityTracking";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";
import PageNames from "../config/pageNames";
import { keyMapsMutation } from "../helpers/storeKeys";
import localStorageFunc from "../helpers/localStorageFunc";
import { CURRENCY_SYMBOL } from "../helpers/paymentConstants";

export default {
  name: "BottomBar",
  props: ["moduleProps"],
  components: {
    MenuModal: defineAsyncComponent(() => import("./BottomBarMenuModal.vue")),
    NewMenuModal: defineAsyncComponent(() =>
      import("./BottomBarNewMenuModal.vue")
    ),
    OfferAppliedMessage: defineAsyncComponent(() =>
      import("./OfferAppliedMessage.vue")
    ),
    PaymentOfferMessage: defineAsyncComponent(() =>
      import("./PaymentOfferMessage.vue")
    ),
  },
  data() {
    return {
      showMenuModal: false,
      modulePropsData : {},
      currencySymbol: CURRENCY_SYMBOL,
    };
  },
  mounted(){
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}, eventName = "") {
      let eventType = isClicked ? "Click" : "Impression";
      if (eventName) {
        eventType = eventName;
      }
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = { ...eObj };
      let sectionPosition = preEventObj["sectionPosition"];
      delete preEventObj["sectionPosition"];
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        preEventObj["screenName"] == PageNames.NEXTGEN_SEARCHPAGE
          ? "search"
          : preEventObj["sectionName"]
          ? preEventObj["sectionName"]
          : "bottom menu",
        sectionPosition,
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    triggerMenuModal(e) {
      //Amplitude click event load
      this.eventFunction(true, { category: "menu" });
      document.body.classList.add("body-stop-scroll-mobile");
      this.showMenuModal = true;
      //Amplitude impression event load
      this.eventFunction(false, { category: "menu" });
      userActivityTracking.menuOpen(0);
    },
    triggerNewMenuModal() {
      let menuArray = [];
      menuArray = Object.keys(this.getBottomBarData).map(item => item.toLowerCase()).filter(item => item != "recommendations");
     
      let _ = (this.productCounterString && !this.productCounterString.startsWith('undefined')) ?this.productCounterString:"";
      let tempCategory = _ ? _.split("|")[0].replace("Showing", "").trim().toLowerCase() : ""; //Non-Veg Pizza
      
      //Amplitude click event load
      if(!this.isViewAllCategoryVariant){
        this.eventFunction(true, {
        positionWithinSection: "",
        sectionName: "full menu",
        category: tempCategory, 
        subCategory: tempCategory, 
        subSection: "bottom menu",
        sectionPosition:"-1"
      });
      }

      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_NEW_MENU_MODAL_FLAG, true);
      this.$store.commit(keyMapsMutation.UPDATE_MENU_MODAL_FLAG_OPENED_FROM, "bottom menu");

      //Amplitude impression event load
      this.eventFunction(false, {
        sectionName: "full menu",
        subSection: "bottom menu",
        menuCategories: menuArray,
        sectionPosition:"-1",
        menuCount:menuArray?.length
      });
      userActivityTracking.menuOpen(0);
    },
    closeModalM() {
      this.showMenuModal = false;
    },
    triggerMenuClick(e) {
      if (this.isViewAllCategoryVariant) {
        this.eventFunction(true, { category: "menu" });
        this.triggerNewMenuModal(e);
      } else if (this.isSeparateMenuVariant) {
        // re-direct to separate menu page
        this.eventFunction(true, { category: "menu" });
        let url = 
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          localStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
        window.location.href = url;
      } else {
        this.triggerMenuModal(e);
      }
    },
    triggerHomeClick(e) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    handlePizza99(event, isEdvVisible) {
      //Amplitude click event load
      if(!isEdvVisible){
        this.eventFunction(true, { category: "deals & offers" });
        let endPoint = this.modulePropsData?.dealsAndOffersUrl;
        if(!endPoint || endPoint == 'null' || endPoint == 'undefined'){
          endPoint = 'offers'
        }
        let redirectUrl = `${v2PwaBasePath}/${endPoint}`
        window.location.href = redirectUrl;
      }
      else{
        this.eventFunction(true, { category: "1 + 1 Offer" });
        window.location.href = Utility.getEdvPageUrl(this.modulePropsData?.edvType);
        userActivityTracking.pizza99(0);
      }
    },
    handleCartClick(event, item) {
      //Amplitude click event load
      LocalStorageFunc.setTrackerOfKeyInSession(true);
      this.eventFunction(true, { category: "view cart" });
      userActivityTracking.checkout(0);
      Utility.sendToNextGenCart();
    },
  },
  computed: {
    cartQuantity() {
      let _ = this.$store.getters[keyMapsGetter.CART_QUANTITY];
      let initialCartUpdatedByUserActionRef =
        this.$store.state.Cart.initialCartUpdatedByUserActionRef;
      if (initialCartUpdatedByUserActionRef.type == "NONE") {
        return _;
      }

      let preEventObj = {
        eventCategory: "ecommerce",
        eventAction:
          initialCartUpdatedByUserActionRef.type == "REMOVE"
            ? "remove from cart"
            : "add to cart",
        addToCartQuantity:
          initialCartUpdatedByUserActionRef.type == "REMOVE" ? -1 : 1,
        itemName: initialCartUpdatedByUserActionRef.item?.name?.toLowerCase(),
        price: initialCartUpdatedByUserActionRef.item?.itemPrice,
        itemSku: initialCartUpdatedByUserActionRef.item?.id,
        isIrctcOrder: "no",
        size: initialCartUpdatedByUserActionRef.item?.sizeName?.toLowerCase(),
        crust: initialCartUpdatedByUserActionRef.item?.crustName?.toLowerCase(),
        ecomCategory:
          initialCartUpdatedByUserActionRef.item?.name?.toLowerCase(),
        positionWithinSection:
          initialCartUpdatedByUserActionRef.positionWithinSection,
        mealOriginalPrice: initialCartUpdatedByUserActionRef?.mealOriginalPrice,
        mealFinalPrice: initialCartUpdatedByUserActionRef?.mealFinalPrice,
        mealSavings: initialCartUpdatedByUserActionRef?.mealSavings,
      };

      if (initialCartUpdatedByUserActionRef.source == "searchModal") {
        if (
          initialCartUpdatedByUserActionRef.subSource ==
          "nonCustomizableCardAdd"
        ) {
          preEventObj["screenName"] =
            PageNames.NEXTGEN_SEARCH_NON_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
        } else if (
          initialCartUpdatedByUserActionRef.subSource == "customisation"
        ) {
          preEventObj["screenName"] =
            PageNames.NEXTGEN_SEARCH_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_SEARCHPAGE;
        } else {
          preEventObj["screenName"] = PageNames.NEXTGEN_SEARCHPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        }
      } else {
        if (
          initialCartUpdatedByUserActionRef.subSource ==
          "nonCustomizableCardAdd"
        ) {
          preEventObj["screenName"] = PageNames.NEXTGEN_NON_CUSTOMISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        } else if (
          initialCartUpdatedByUserActionRef.subSource == "customisation"
        ) {
          preEventObj["screenName"] = PageNames.NEXTGEN_CUSTOISATIONPAGE;
          preEventObj["previousScreenname"] = PageNames.NEXTGEN_HOMEPAGE;
        }
      }

      preEventObj["sectionPosition"] =
        initialCartUpdatedByUserActionRef.sectionPosition;

      if (initialCartUpdatedByUserActionRef.sectionName) {
        preEventObj["sectionName"] =
          initialCartUpdatedByUserActionRef.sectionName;
      }

      this.eventFunction(
        true,
        preEventObj,
        initialCartUpdatedByUserActionRef.type == "REMOVE"
          ? "removeFromCart"
          : "addToCart"
      );
      return _;
    },
    cartTotal() {
      return this.$store.getters[keyMapsGetter.CART_TOTAL];
    },
    welcomeOffers() {
      return this.$store.state.Offers.welcomeOffers;
    },
    paymentOffers() {
      return this.$store.state.PaymentOffers.paymentOffers;
    },
    checkoutTitle() {
      let checkoutTitleText = "View Cart";
      let exp = this.$store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_I ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_L
      ) {
        checkoutTitleText = "View Cart";
      } else if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_J ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ==
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_M
      ) {
        checkoutTitleText = "View Cart";
      }
      return checkoutTitleText;
    },
    hideCartTotal() {
      let exp = this.$store.getters[keyMapsGetter.GET_VWO_EXPERIMENTS];
      return true; // for all variant as per standup discussion
      // return [
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_K,
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_L,
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_M,
      //   VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U
      // ].includes(exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT]);
    },
    showNewMenuModal() {
      return this.$store.state.Menu.showMenuModalFlag;
    },
    isNewHomeBtnVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        (
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
            VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_S &&
          Utility.getLinkRewriteFromSiteprops() !== 
            PageNames.NEXTGEN_LINKREWRITE_HOME
        ) ||
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.CONTROL
      ) {
        return true;
      } else {
        return false;
      }
    },
    isViewAllCategoryVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_T
      ) {
        return true;
      } else {
        return false;
      }
    },
    productCounterString() {
      return this.$store.state.ProductItems.productCounterString;
    },
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      let variant = exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
      if(
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_W ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_X ||
        variant === VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_Y ||
        (
          Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME ||
          Utility.getLinkRewriteFromSiteprops() === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    edvRebrandingTitle() {
      return this.$store.state.Config.appConfig.config.edvRebrandingTitle;
    },
    isConfigStatic() {
      return this.$store.state.Config.isStatic;
    },
    shouldEdvVisible() {
      let edvInStore = this.$store.state.Location.storeDetails?.edvEnable;
      return (edvInStore !== undefined && edvInStore) ? edvInStore : false ; 
    },
  },
};
</script>
